import React from 'react';
import { FormProps, Modal, ModalBody } from 'react-bootstrap';
import AddressForm, { Address } from '.';

export type customAddressFormModalProps = React.PropsWithoutRef<{
  showModal: boolean;
  existingAddress?: Address;
  handleClose: () => void;
  handleSubmit: (formData: any) => void;
  formProps?: FormProps;
}>;

const AddressFormModal = ({
  showModal = false,
  existingAddress,
  handleClose,
  handleSubmit,
  formProps,
  ...props
}: customAddressFormModalProps) => {
  return (
    <Modal show={showModal} onHide={handleClose} {...props} size="lg">
      <ModalBody className="pt-12">
        <AddressForm
          existingAddress={existingAddress}
          handleClose={handleClose}
          handleOnSubmit={handleSubmit}
          {...formProps}
        />
      </ModalBody>
    </Modal>
  );
};

export default AddressFormModal;
